import dayjs from 'dayjs';
import { Filters } from 'react-table';

import { MinMaxStringValues } from '../../../../apis/graphql/types';
import { DateRangeFilter } from '../../../../components/BlueTheme/Filter';
import { defaultDateFormatForBeServices } from '../../../../constants/dates';
import { getYesterday } from '../../Reports/ReportFilterModal/utils';
import { LINE_ITEM_END_DATE_COLUMN_ID } from '../constants';

type Props = {
  filters: Filters<{}>;
  filterValue: MinMaxStringValues;
  setFilter: (updater?: MinMaxStringValues) => void;
  onFilterChanged: (value?: MinMaxStringValues) => void;
};

const LineStartFilter = ({ filters, filterValue, setFilter, onFilterChanged }: Props): JSX.Element => {
  const endDateRangeFilter = filters.find(({ id }) => id === LINE_ITEM_END_DATE_COLUMN_ID);
  const maxPossibleDate = endDateRangeFilter?.value?.max
    ? dayjs(endDateRangeFilter.value.max, { format: defaultDateFormatForBeServices }).toDate()
    : getYesterday();

  const handleFilter = (value?: MinMaxStringValues): void => {
    onFilterChanged(value);
    setFilter(value);
  };

  return (
    <DateRangeFilter
      elementId="lineStartFilter"
      additionalText="Starts"
      choosenDateRange={filterValue}
      maxDate={maxPossibleDate}
      onChange={handleFilter}
    />
  );
};

export default LineStartFilter;
